import { ILanding, LANDING_TYPE_CONTENT } from "../../data/interfaces";
import { useLandingStore } from "../../data/store";

export default function getMeatsByType(type: LANDING_TYPE_CONTENT): any[] {
    let meats: any[] = []
    const currentLanding: ILanding = useLandingStore.getState().currentLanding
    currentLanding.sections.forEach(section => {
        section.data.forEach(meat => {
            if(meat.type === type) {
                meats.push( meat )
            }
            if( !!meat.incut ) {
                meats = [...meats, meat.incut.filter(( m: any ) => m.type === type) ]
            }
        })
        section.floats.forEach(float => {
             
        })
    })

    return meats
}